/**
 * Estimated time card — shows ETA (delivery or pickup) with remaining countdown.
 */

import { Clock } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '@/components/ui'
import type { OrderType } from '@/types/order'

interface OrderEstimatedTimeCardProps {
  orderType: OrderType
  formattedEta: string | null
  timeRemaining: string | null
}

export function OrderEstimatedTimeCard({
  orderType,
  formattedEta,
  timeRemaining,
}: OrderEstimatedTimeCardProps) {
  const { t } = useTranslation()

  return (
    <Card className="mb-6">
      <CardContent className="py-6">
        <div className="flex items-center justify-center gap-4">
          <div className="h-14 w-14 rounded-full bg-primary/10 flex items-center justify-center">
            <Clock className="h-7 w-7 text-primary" />
          </div>
          <div>
            <div className="text-sm text-muted-foreground">
              {orderType === 'delivery'
                ? t('common:estimatedDelivery')
                : t('common:readyForPickup')}
            </div>
            <div className="text-2xl font-bold">
              {formattedEta || timeRemaining}
            </div>
            {timeRemaining && formattedEta && (
              <div className="text-sm text-muted-foreground">
                {t('common:remaining', { time: timeRemaining })}
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
